import { render, staticRenderFns } from "./CommonFormWithDriverEditor.vue?vue&type=template&id=54e7782b&lang=pug&"
import script from "./CommonFormWithDriverEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithDriverEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithDriverEditor.vue?vue&type=style&index=0&id=54e7782b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports